import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-projects7',
  templateUrl: './section-projects7.component.html',
  styleUrls: ['./section-projects7.component.css']
})
export class SectionProjects7Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
